import React, { useState } from "react";
import styled from "styled-components/macro";
import { Popup } from "semantic-ui-react";
import { PopUpItem } from "./PopUpItem";
import handle from "../../images/unit/handle.svg";
import darkHandle from "../../images/unit/darkHandle.svg";

import woodMiddleShelf from "../../images/unit/middle_shelf.png";
import darkMiddleShelf from "../../images/unit/darkMiddleShelf.svg";
import darkBottomShelf from "../../images/unit/darkBottomShelf.svg";
import woodBottomShelf from "../../images/unit/bottom_shelf.png";
import UpperShelfDarkImg from "../../images/unit/upperShelfDark.png";
import UpperShelfImg from "../../images/unit/upperShelf.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUp,
  faArrowDown,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";

const UnitBox = ({
  onPopupOpen,
  onPopupClose,
  popupItem,
  isBottom,
  isTop,
  quantity,
  item,
  colorUnit,
  onRemovePress,
  onUpPress,
  onDownPress,
}) => {
  const {
    size,
    color,
    gradientColor,
    unitImage,
    image,
    frameColor = "#FFFFFF",
    showDoor = true,
    type,
  } = item;

  const [onHover, setOnHover] = useState(false);

  const isDark = colorUnit !== "linear-gradient(to bottom, #f7f7f7, #f1efef)";
  return (
    <BoxWrapper
      isTop={isTop}
      onMouseEnter={() => setOnHover(true)}
      onMouseLeave={() => setOnHover(false)}
    >
      <Popup
        disabled={!image || type === "system"}
        position="right center"
        on="click"
        onOpen={onPopupOpen}
        onClose={onPopupClose}
        trigger={
          <Box style={{ cursor: type === "system" ? null : "pointer" }}>
            <div>
              <Box isTop={isTop} style={{ flexDirection: "row" }}>
                <Wrapper
                  isTop={isTop}
                  frameColor={colorUnit || frameColor}
                  size={size}
                >
                  <InnerWrapper
                    showDoor={showDoor}
                    color={color}
                    gradientColor={gradientColor}
                  >
                    {/*<Shelf color={color} gradientColor={gradientColor} />*/}
                    <UpperLight color={color} />
                    {isTop && (
                      <UpperShelf
                        src={isDark ? UpperShelfDarkImg : UpperShelfImg}
                      />
                    )}

                    {/*{showDoor && <Pin frameColor={colorUnit || frameColor} />}*/}
                    {/*{showDoor && <PinTop frameColor={colorUnit || frameColor} />}*/}
                  </InnerWrapper>
                </Wrapper>
                {/*{showRightDivider && <DividerVertical size={size} />}*/}
              </Box>
            </div>
            <DividerHorizontal />

            <div
              style={{
                position: "absolute",
                left: 0,
                right: 0,
                bottom: "15px",
                top: 0,
                zIndex: 100,
                alignItems: "flex-end",
                display: "flex",
              }}
            >
              {isTop && (
                <UpperShelf src={isDark ? UpperShelfDarkImg : UpperShelfImg} />
              )}
              {unitImage && (
                <img
                  src={unitImage}
                  style={{ objectFit: "contain", zIndex: 555 }}
                  alt={"Product"}
                />
              )}
            </div>

            {isBottom ? (
              <BottomShelf
                className="bottomShelf"
                src={!isDark ? woodBottomShelf : darkBottomShelf}
              />
            ) : (
              <MiddleShelf
                className="middleShelf"
                style={{ objectFit: isDark && "none" }}
                src={!isDark ? woodMiddleShelf : darkMiddleShelf}
              />
            )}
            {showDoor && (
              <Rect
                src={isDark ? darkHandle : handle}
                style={{ margin: isTop && "10px 0px 0px 0px" }}
              />
            )}

            <ShadowBackground
              style={{
                opacity: !popupItem ? 0 : popupItem.id === item.id ? 0 : 0.5,
              }}
            />
          </Box>
        }
        flowing
      >
        <PopUpItem item={item} quantity={quantity} />
      </Popup>
      {onRemovePress && !popupItem && onHover && (
        <FontAwesomeIcon
          onClick={onRemovePress}
          style={{
            filter: "drop-shadow(0px 0px 1px black)",
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: 9999999999,
            padding: "10px",
            cursor: "pointer",
          }}
          size={"2x"}
          color={"white"}
          icon={faTimesCircle}
        />
      )}
      {onUpPress && !popupItem && !isTop && onHover && (
        <FontAwesomeIcon
          onClick={onUpPress}
          style={{
            filter: "drop-shadow(0px 0px 1px black)",
            position: "absolute",
            top: -2,
            right: 0,
            left: 0,
            padding: "3px",
            margin: "auto",
            zIndex: 9999999999,
            cursor: "pointer",
          }}
          size={"2x"}
          color={"white"}
          icon={faArrowUp}
        />
      )}
      {onDownPress && !popupItem && !isBottom && onHover && (
        <FontAwesomeIcon
          onClick={onDownPress}
          style={{
            filter: "drop-shadow(0px 0px 1px black)",
            position: "absolute",
            bottom: 6,
            right: 0,
            left: 0,
            padding: "3px",
            margin: "auto",
            zIndex: 9999999999,
            cursor: "pointer",
          }}
          size={"2x"}
          color={"white"}
          icon={faArrowDown}
        />
      )}
    </BoxWrapper>
  );
};

const Box = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
`;

const ShadowBackground = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: #4b4b4b;
  z-index: 9999999;
  transition: all 300ms ease-in-out;
`;

const Wrapper = styled.div`
  z-index: 3;
  width: 180px; //166px;
  height: ${({ size, isTop }) => {
    if (isTop) {
      return size + 9;
    }
    return size;
  }}px;
  //border: 7px solid ${({ frameColor }) => frameColor};
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  border-radius: 2px;
`;

const MiddleShelf = styled.img`
  z-index: 4;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
`;

const BottomShelf = styled.img`
  z-index: 4;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
`;

const InnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  box-shadow: ${({ showDoor }) =>
    showDoor ? "0 3px 6px 0 rgba(0, 0, 0, 0.16)" : null};
  box-shadow: ${({ showDoor }) =>
    showDoor ? "inset 2px 2px 10px 5px rgba(0,0,0,0.16)" : null};
  background-image: linear-gradient(
    to bottom,
    ${({ color }) => color},
    ${({ gradientColor }) => gradientColor} 95%
  );
`;
//
// const Shelf = styled.div`
//   position: absolute;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   height: 14px;
//   background-image: linear-gradient(to bottom, #efe8de, #efe8de 65%);
//   z-index: 0;
// `

const UpperShelf = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  margin-top: -2px;
`;
const UpperLight = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 35px;
  background-image: linear-gradient(
    rgba(255, 255, 255, 0.51),
    rgba(254, 255, 253, 1),
    rgba(253, 254, 251, 0.26),
    rgba(253, 254, 249, 0.08),
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0)
  );
  z-index: 0;
  opacity: 0.6;
`;

const Rect = styled.img`
  position: absolute;
  left: -1px;
  width: 42px;
  height: 25px;
  z-index: 99999999999999;
`;
const DividerHorizontal = styled.div`
  width: 180px;
  height: 18px;
  background-image: linear-gradient(to bottom, #f6f3ee, #f9f3e9);
  border-top: #f7f7f7 1px solid;
  //align-self: center;
`;

const BoxWrapper = styled.div`
  display: flex;
  position: relative;
  /* height: ${({ isTop }) => {
    return isTop && "110px";
  }}; */
`;
export { UnitBox };
